import React from "react"
import BookMeetProvider from "../../bookMeet/bookMeetContext"
import BookMeetModal from "../../bookMeet/bookMeetModal"
import { getUserFromMeetLink } from "../../../library/store/actions/creators/authCreators"
import useCreator from "../../../hooks/useCreator"
import { useParams } from "react-router-dom"
import Loader from "../../../components/ui/loader"

const CreateMeetAsGuest = () => {
  const creator = useCreator()
  const { userId } = useParams()
  const [user, setUser] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(() => {
    const getUser = async () => {
      const meetUser = await creator(
        getUserFromMeetLink({ id: Number(userId) })
      )
      setUser(meetUser)
      setIsLoading(false)
    }
    getUser()
  }, [])

  return !isLoading ? (
    <BookMeetProvider user={user}>
      <BookMeetModal />
    </BookMeetProvider>
  ) : (
    <Loader />
  )
}

export default CreateMeetAsGuest
